import { BrowserRouter } from "react-router-dom";

import Context from "./Context";

// siteNavigator
import SiteNavigator from "./SiteNavigator";

function App() {
  return (
    <BrowserRouter>
      <Context>
        <SiteNavigator />
      </Context>
    </BrowserRouter>
  );
}

export default App;
